import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

// Layout Components
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";

// Pages
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import ProcessPage from "./pages/ProcessPage";
import SustainabilityPage from "./pages/SustainabilityPage";
import InsightsPage from "./pages/InsightsPage";
import ContactPage from "./pages/ContactPage";

// Admin
import LoginPage from "./pages/admin/LoginPage";
import AdminLayout from "./pages/admin/AdminLayout";
import DashboardPage from "./pages/admin/DashboardPage";
import SubmissionsPage from "./pages/admin/SubmissionsPage";
import PostsPage from "./pages/admin/PostsPage";
import NewsPage from "./pages/admin/NewsPage";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

// Layout wrapper for public pages (with header/footer)
const PublicLayout = ({ children }) => (
  <>
    <Header />
    {children}
    <Footer />
  </>
);

function App() {
  return (
    <div className="App bg-black min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Admin Routes */}
          <Route path="/admin/login" element={<LoginPage />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<DashboardPage />} />
            <Route path="submissions" element={<SubmissionsPage />} />
            <Route path="posts" element={<PostsPage />} />
            <Route path="news" element={<NewsPage />} />
          </Route>

          {/* Public Routes */}
          <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
          <Route path="/about" element={<PublicLayout><AboutPage /></PublicLayout>} />
          <Route path="/services" element={<PublicLayout><ServicesPage /></PublicLayout>} />
          <Route path="/process" element={<PublicLayout><ProcessPage /></PublicLayout>} />
          <Route path="/sustainability" element={<PublicLayout><SustainabilityPage /></PublicLayout>} />
          <Route path="/insights" element={<PublicLayout><InsightsPage /></PublicLayout>} />
          <Route path="/contact" element={<PublicLayout><ContactPage /></PublicLayout>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
